import { Props, defaultAccept, defaultHeading, defaultId } from './utils';
import Upload from './Upload';
import Progress from './Progress';

export default function FileUpload({
  id = defaultId,
  heading = defaultHeading,
  helper = '',
  onChange,
  onRemove,
  multiple = false,
  accept = defaultAccept,
  progress = 0,
  fileSize = 0,
  fileName = '',
  success = false,
  error = false,
  invalid = false,
}: Props) {
  // If file upload progress or error
  if (progress || error)
    return (
      <Progress
        fileName={fileName}
        progress={progress}
        fileSize={fileSize}
        success={success}
        error={error}
        invalid={invalid}
        onRemove={onRemove}
      />
    );

  // Initial state by default
  return (
    <>
      <Upload
        id={id}
        heading={heading}
        helper={helper}
        onChange={onChange}
        multiple={multiple}
        accept={accept}
        invalid={invalid}
      />
    </>
  );
}
